// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { createContext } from 'react';

export const InfoLinkLabelContext = createContext<string | undefined>(undefined);



// WEBPACK FOOTER //
// /Volumes/src/internal/context/info-link-label-context.ts